import type { Resource } from '../../';
export const product_sizeChart_measurements_cn: Resource = {"default":"China"};
